<template>
    <div
        class="apprentice-simple-card test-page"
        dusk="test-component">
        <div class="test-wrapper">
            <!-- Start screen -->
            <div
                class="test-splash-screen"
                v-if="currentQuestionIndex === 0">
                <div
                    class="test-description"
                    v-html="test.description"></div>

                <b-button
                    class="btn-play btn-start-test"
                    variant="primary"
                    @click="nextQuestion"
                    dusk="start-test-button"
                    >{{ $t('testcenter.start') }}
                </b-button>
            </div>

            <!-- Final screen -->
            <div
                class="test-submit"
                v-else-if="allQuestionsAnswered">
                <p class="test-description">
                    {{ $t('testcenter.you_answered_all_questions') }}<br />
                    {{ $t('testcenter.click_submit_test_to_submit_your_answers') }}
                </p>

                <div class="question-controls">
                    <b-button
                        class="btn-previous"
                        variant="outline-primary"
                        @click="previousQuestion"
                        dusk="previous-button"
                        >{{ $t('common.previous') }}
                    </b-button>

                    <b-button
                        class="btn-forward"
                        variant="primary"
                        @click="submitTestResponse"
                        dusk="submit-test-response-button"
                        >{{ $t('testcenter.submit_test') }}
                    </b-button>
                </div>
            </div>

            <!-- Question screen -->
            <div
                class="question"
                v-else>
                <p class="question-count">
                    {{
                        $t('testcenter.question_current_of_total', {
                            current: currentQuestion.index,
                            total: questions.length,
                        })
                    }}
                    <b-progress
                        class="test-progress"
                        variant="primary"
                        :value="currentQuestionIndex"
                        :max="questions.length">
                    </b-progress>
                </p>

                <p class="question-text">{{ currentQuestion.text }}</p>

                <ul
                    class="answers"
                    v-if="currentQuestion?.question_type === 'multiple_choice'">
                    <li class="answer">
                        <b-form-radio-group
                            class="multiple-choice-question"
                            v-model="selectedOptionKey"
                            :label="currentQuestion.text">
                            <b-form-radio
                                class="apprentice-radiobutton"
                                v-for="option in currentQuestion?.options"
                                :key="option.key"
                                :value="option.key">
                                {{ option.text }}
                            </b-form-radio>
                        </b-form-radio-group>
                    </li>
                </ul>

                <div class="question-controls">
                    <b-button
                        class="btn-previous"
                        variant="outline-primary"
                        dusk="previous-button"
                        @click="previousQuestion">
                        {{ $t('common.previous') }}
                    </b-button>

                    <b-button
                        class="btn-forward"
                        variant="primary"
                        :disabled="selectedOptionKey == null"
                        dusk="next-question-button"
                        @click="nextQuestion">
                        {{ $t('common.next') }}
                    </b-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import _ from 'lodash';

export default {
    props: {
        testResponseIn: {
            type: Object,
        },
        submittedAnswerKeysIn: {
            type: Array,
        },
    },

    data() {
        return {
            testResponse: this.testResponseIn,
            test: this.testResponseIn.test_issuing.test,
            questions: this.testResponseIn.test_issuing.test.questions,
            submittedAnswerKeys: this.submittedAnswerKeysIn,
            currentQuestionIndex: this.submittedAnswerKeysIn.length - 1, // Includes a `null` on index 0 used to aid serialization in PHP
            selectedOptionKey: null,
        };
    },

    mounted() {
        if (this.currentQuestionIndex === 0) {
            // Shows the start screen
            return;
        }

        this.loadQuestion(this.currentQuestionIndex + 1);
    },

    computed: {
        currentQuestion() {
            return this.questions?.find((question) => question.index === this.currentQuestionIndex);
        },

        allQuestionsAnswered() {
            return this.currentQuestionIndex > _.maxBy(this.questions, (question) => question.index).index;
        },
    },

    methods: {
        previousQuestion() {
            this.loadQuestion(this.currentQuestionIndex - 1);
        },

        nextQuestion() {
            if (this.currentQuestionIndex !== 0 && this.selectedOptionKey == null) {
                return;
            }

            if (
                this.selectedOptionKey !== null &&
                this.selectedOptionKey !== this.submittedAnswerKeys[this.currentQuestionIndex]
            ) {
                this.submitAnswer();
            }

            this.loadQuestion(this.currentQuestionIndex + 1);
        },

        loadQuestion(index) {
            this.currentQuestionIndex = index;
            this.selectedOptionKey = this.submittedAnswerKeys[index] ?? null;
        },

        submitAnswer() {
            this.submittedAnswerKeys[this.currentQuestionIndex] = this.selectedOptionKey;

            let data = {
                option_key: this.selectedOptionKey,
            };

            this.axios.post(this.routes.testResponseAnswer(this.testResponse.id, this.currentQuestion.id), data).then(
                () => {},
                () => {
                    this.alert.ajaxError(error);
                },
            );
        },

        submitTestResponse() {
            this.axios.post(this.routes.testResponseSubmit(this.testResponse.id)).then(
                () => {
                    this.alert.success(this.$t('testcenter.test_submitted'));
                    window.location.href = this.routes.testResponseResult(this.testResponse.id);
                },
                () => {
                    this.alert.ajaxError(error);
                },
            );
        },
    },
};
</script>

<style scoped lang="scss"></style>
